<template>
           <aside class="aside-menu">
        
     
    </aside>
</template>

<script>

export default {
  name: 'c-aside',
  components: {
  
        },
        computed: {
            inheritance: function () {
                return this.$store.state.inheritance;
            }
        }
}
</script>
